export enum ECurrencySymbol {
  USD = '$',
  EUR = '€',
  GBP = '£',
  INR = '₹',
}
